export default __webpack_public_path__ + "static/media/comms_inactive.ebe1339f.svg";